module.exports = __webpack_public_path__ + "static/media/video-icon.f55f76c5.png";